import '../App.css';
import NftAttribute from './NftAttribute';
import renderingImage from '../imgs/vpcMinValuesRendering2.png';

var NftCard = (props) => {
  if (typeof props.nft === 'undefined') return null;

  const { royalties, mandates, img, TVR, id } = props.nft;
  let attributes = [];
  royalties.forEach((attr, i) => {
    if (i % 4 === 0) attributes.push(<br key={`br-${i}`} />);
    const tv = mandates[i]?.[0] ? [mandates[i][0], attr] : ['err', 'err'];
    attributes.push(<NftAttribute key={i} textValue={tv} />);
  });

  return (
    <div className="nft-card-box">
      <img
        className="nft-card-img"
        alt={img === null ? 'rendering in progress' : 'ImpactKey'}
        src={img === null ? renderingImage : img}
      />
      <div className="nft-name-text">ImpactKey #{id}</div>
      {attributes}
      {(attributes.length % 5 === 0) && <br />}
      {TVR === null
        ? <NftAttribute textValue={['calculating TVR']} />
        : <NftAttribute textValue={['TVR', TVR]} />
      }
    </div>
  );
};

export default NftCard;
